import { render, staticRenderFns } from "./gc-header-content-static.vue?vue&type=template&id=3e923828"
import script from "./gc-header-content-static.vue?vue&type=script&lang=js"
export * from "./gc-header-content-static.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports